import { useLanguage } from '../context/LanguageContext';

const PrivacyPolicy = () => {
  const { language } = useLanguage();

  const content = {
    pl: {
      title: "Polityka Prywatności",
      lastUpdate: "Ostatnia aktualizacja: Kwiecień 2026",
      sections: [
        {
          title: "1. Administrator danych",
          text: "Administratorem Twoich danych osobowych jest SPRZĘT PRO z siedzibą w Polsce. Kontakt: propoziom@gmail.com"
        },
        {
          title: "2. Jakie dane zbieramy",
          text: "Zbieramy następujące dane: imię i nazwisko, adres email, adres dostawy, numer telefonu, historię zamówień. Dane te są niezbędne do realizacji zamówień i świadczenia usług."
        },
        {
          title: "3. Cel przetwarzania danych",
          text: "Twoje dane przetwarzamy w celu: realizacji zamówień, kontaktu w sprawie zamówienia, wysyłki newslettera (za zgodą), doskonalenia naszych usług."
        },
        {
          title: "4. Udostępnianie danych",
          text: "Twoje dane mogą być udostępniane: firmom kurierskim (InPost, DPD) w celu dostawy, operatorowi płatności (PayU) w celu realizacji transakcji. Nie sprzedajemy danych osobowych podmiotom trzecim."
        },
        {
          title: "5. Okres przechowywania",
          text: "Dane przechowujemy przez okres niezbędny do realizacji zamówienia oraz przez okres wymagany przepisami prawa (np. dla celów podatkowych - 5 lat)."
        },
        {
          title: "6. Twoje prawa",
          text: "Masz prawo do: dostępu do swoich danych, sprostowania danych, usunięcia danych ('prawo do bycia zapomnianym'), ograniczenia przetwarzania, przenoszenia danych, sprzeciwu wobec przetwarzania."
        },
        {
          title: "7. Pliki cookies",
          text: "Używamy plików cookies w celu zapewnienia prawidłowego działania strony, analizy ruchu oraz personalizacji treści. Możesz zarządzać ustawieniami cookies w swojej przeglądarce."
        },
        {
          title: "8. Bezpieczeństwo",
          text: "Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych osobowych przed nieuprawnionym dostępem, utratą lub zniszczeniem."
        },
        {
          title: "9. Kontakt",
          text: "W sprawach związanych z ochroną danych osobowych możesz kontaktować się z nami pod adresem: propoziom@gmail.com"
        }
      ]
    },
    ru: {
      title: "Политика конфиденциальности",
      lastUpdate: "Последнее обновление: Апрель 2026",
      sections: [
        {
          title: "1. Администратор данных",
          text: "Администратором ваших персональных данных является SPRZĘT PRO с местонахождением в Польше. Контакт: propoziom@gmail.com"
        },
        {
          title: "2. Какие данные мы собираем",
          text: "Мы собираем следующие данные: имя и фамилия, email, адрес доставки, номер телефона, история заказов. Эти данные необходимы для выполнения заказов и предоставления услуг."
        },
        {
          title: "3. Цель обработки данных",
          text: "Ваши данные обрабатываются для: выполнения заказов, связи по поводу заказа, рассылки новостей (с согласия), улучшения наших услуг."
        },
        {
          title: "4. Передача данных",
          text: "Ваши данные могут передаваться: курьерским службам (InPost, DPD) для доставки, оператору платежей (PayU) для проведения транзакций. Мы не продаём персональные данные третьим лицам."
        },
        {
          title: "5. Срок хранения",
          text: "Данные хранятся в течение периода, необходимого для выполнения заказа, а также в течение периода, требуемого законодательством (например, для налоговых целей - 5 лет)."
        },
        {
          title: "6. Ваши права",
          text: "Вы имеете право на: доступ к своим данным, исправление данных, удаление данных ('право быть забытым'), ограничение обработки, перенос данных, возражение против обработки."
        },
        {
          title: "7. Файлы cookies",
          text: "Мы используем файлы cookies для обеспечения правильной работы сайта, анализа трафика и персонализации контента. Вы можете управлять настройками cookies в своём браузере."
        },
        {
          title: "8. Безопасность",
          text: "Мы применяем соответствующие технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, потери или уничтожения."
        },
        {
          title: "9. Контакт",
          text: "По вопросам защиты персональных данных вы можете связаться с нами по адресу: propoziom@gmail.com"
        }
      ]
    }
  };

  const t = content[language] || content.pl;

  return (
    <div className="min-h-screen py-16" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl sm:text-5xl uppercase text-white mb-4">
          {t.title}
        </h1>
        <p className="text-zinc-500 mb-8">{t.lastUpdate}</p>

        <div className="space-y-8">
          {t.sections.map((section, index) => (
            <div key={index} className="border border-zinc-800 bg-[#111111] p-6">
              <h2 className="font-heading text-xl uppercase text-yellow-400 mb-3">
                {section.title}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {section.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
